import {makeAutoObservable} from "mobx";
import {IProductCaseQuestion} from "../rma-types";
import AnswerStore from "./answer-store";
import QuestionMediaStore from "./question-media-store";


class QuestionStore {
    private _model: IProductCaseQuestion = {} as IProductCaseQuestion;
    
    private _answerStores: AnswerStore[] = [];
    private _mediaList: QuestionMediaStore[] = [];
    
    constructor(model: IProductCaseQuestion) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._setModel(model);
    }
    
    private _setModel(model: IProductCaseQuestion) {
        if (model) {
            this._model = model;
            this._answerStores = model.answers.map(a => new AnswerStore(a));
            this._mediaList = model.images.map(m => new QuestionMediaStore(m));
        }
    }
    public get id(): number { return this._model.id; }
    public get translation(): string { return this._model.translation;}
    public get answers(): AnswerStore[] { return this._answerStores; }
    public get mediaList(): QuestionMediaStore[] { return this._mediaList; }
}

export { QuestionStore as default };
